<script setup lang="ts">
import PhosphorIcon from "@/components/UI/PhosphorIcon.vue";

/** Recherche dans les 4 catégories de l'onglet Objets. */
const query = defineModel<string>({ required: true });
</script>

<template>
  <label class="objects-search">
    <PhosphorIcon name="magnifying-glass" :size="15" class="search-icon" />
    <input
      v-model="query"
      type="search"
      class="search-input"
      :placeholder="$t('canvas:settings.objects.search')"
      :aria-label="$t('canvas:settings.objects.search')"
      autocomplete="off"
      spellcheck="false"
    />
    <button
      v-if="query"
      type="button"
      class="search-clear"
      :aria-label="$t('canvas:settings.objects.clearSearch')"
      @click="query = ''"
    >
      <PhosphorIcon name="x" :size="13" weight="bold" />
    </button>
  </label>
</template>

<style lang="scss" scoped>
.objects-search {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  margin: 0;
  padding: 0 6px 0 10px;
  border: 1px solid var(--canvas-border);
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.04);
  color: rgba(255, 255, 255, 0.5);

  &:focus-within {
    border-color: var(--canvas-btn-active-bg);
  }
}

.search-icon {
  flex-shrink: 0;
}

.search-input {
  flex: 1 1 auto;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  color: #fff;
  font-size: 13px;

  &::placeholder {
    color: rgba(255, 255, 255, 0.45);
  }

  // La croix native du champ « search » fait doublon avec la nôtre.
  &::-webkit-search-cancel-button {
    display: none;
  }
}

.search-clear {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  flex-shrink: 0;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;

  &:hover {
    background-color: var(--canvas-btn-hover-bg);
    color: #fff;
  }
}
</style>
